<template>
  <div>
    <div class="conDetail">
      <h4 style="text-align: center;">铜仁学院省级专业技术人员继续教育培训平台注册协议</h4>

     本协议由用户（以下简称 “用户”）与铜仁学院省级专业技术人员继续教育培训平台（以下简称
      “平台”）签订，铜仁学院作为贵州省省级专业技术人员继续教育基地，负责平台运营与管理，为专业技术人员提供继续教育网络学习服务。用户完成注册即视为同意本协议所有条款，协议内容如下：
      <br />
      一、协议主体与服务内容<br />
      协议主体：甲方为铜仁学院（省级专业技术人员继续教育基地），乙方为注册使用平台的专业技术人员。
      服务内容：平台提供公需科目与专业科目继续教育网络课程的在线学习、学时记录及学时证明生成等服务。 <br />
      二、用户注册与账号管理<br />
      注册信息：用户须使用真实姓名、身份证号、手机号等真实、准确、完整信息注册，确保信息及时更新，因信息虚假、错误导致的后果由用户自行承担。
      账号安全：用户应设置独立账号和密码，妥善保管账号信息，对账号下所有行为负责。账号不得转让、出借，若因用户原因导致账号被盗用，平台不承担赔偿责任。
      <br />三、用户权利与义务 <br />
      （1）用户权利<br /> 自主选择平台课程，完成学习并通过测试后，获取相应学时证明与合格证书。<br />
      享受平台提供的学习资源、在线答疑、学习进度跟踪等服务。 对平台服务质量、课程内容等提出建议和投诉。<br />
       （2）用户义务<br />
      遵守国家法律法规及平台规则，不得利用平台从事违法违规活动。 尊重知识产权，不得非法复制、传播平台课程及资料。
      不得干扰平台正常运行及其他用户学习，遵守平台社区行为规范。
      <br /> 四、平台权利与义务 <br />
      （1）平台权利<br />
      有权审核用户注册信息，对违规账号采取暂停、终止服务等措施。 有权根据实际情况调整课程内容、服务方式及收费标准。
      有权对用户学习数据进行统计、分析，用于平台优化与管理。<br />
       （2）平台义务<br /> 保障平台正常运行，提供技术支持，及时解决用户使用问题。
      保护用户个人信息安全，采取必要措施防止信息泄露，泄露时及时通知用户并采取补救措施。 提供优质课程资源，确保内容符合继续教育相关规定。
      <br />五、费用与支付 <br />平台课程收费标准将在平台公示，用户可自主查阅并选择支付方式完成缴费。
      费用支付后，除特殊情况（如课程取消、技术故障导致无法学习等）外，不予退还。 
      <br />六、知识产权<br />
      平台所有课程内容、教学资料、技术成果等知识产权归铜仁学院或相关权利人所有。
      用户仅可在平台内用于个人继续教育学习，不得用于商业用途或非法传播。<br />
       七、隐私保护<br />
      平台收集用户信息仅用于提供服务、身份认证、学时记录等，不得擅自泄露给第三方。
      用户可查询、更正个人信息，平台将按规定存储和保护用户信息。<br /> 八、违约责任<br />
      用户违反协议约定，平台有权暂停或终止账号服务，追回非法所得，用户需承担相应法律责任。
      平台因自身原因导致服务中断或用户损失，应承担相应赔偿责任（不可抗力除外）。<br /> 九、协议变更与终止<br />
      平台可根据政策调整等情况变更协议内容，变更后将通过平台公告等方式通知用户，用户继续使用服务视为同意变更。
      协议自用户注册成功之日起生效，用户注销账号或平台终止服务时协议终止。<br /> 十、其他<br /> 本协议未尽事宜，按国家、贵州省及铜仁市相关继续教育规定。
      双方因协议产生的争议，应协商解决；协商不成的，可向有管辖权的人民法院提起诉讼。
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style>
/* //@import url(); 引入公共css类 */
</style>